module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABQklEQVR4AWMYHODnLYb/768x/c9dJPvfoEsLL85cKPf/9RXm/yA9cANWTWUACkDwjM0i/426sWuevEkUrm7DLJABCPC/KIXh/7cbEMnDR7j/201Qh2u06df4v+8QD1xzdQ5IM5oBIOxgwfD/6QmIoocXWf9HzFL6HzxD+f/d82xgseenGf672YHVYhoAw7JSDP+PrIEY8uUG4/+vQAxin9rI8F9BBq4O0wBkzMPF8P/sFkS4XN3F8J+fFyxH2ABxUYb/+5ZDNH67yQjCQDbEVbJSBAywNmb4/+gYRPOTSyz/Y+co/o+erQgKD6AYRM7ODIcBOfEM/z9fhWg+fozrv/MkNXgsOE5U/3/0KDdQDhJT+YloBizsRfh3/jZhbOkALDZ3qzBc3ZIJSAaABD5dZ/xfulSGYEosWCwLSrWQlDg8AAALRjU0Skg/CwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/JM.png
// module id = 1175
// module chunks = 0